import * as tslib_1 from "tslib";
import { hideFullOptions } from 'owa-options-orchestration';
import { saveOptions, discardOptions } from 'owa-options-orchestration';
import { getStore, getCurrentSubcategoryLoadState } from 'owa-options-store';
import { observer } from 'mobx-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { isAnyOptionDirty, hideSaveDiscardButtons, shouldDisableSaveButton, } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./OptionsFull.scss');
var SettingsFormHeader = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsFormHeader, _super);
    function SettingsFormHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsFormHeader.prototype.render = function () {
        var store = getStore();
        var selectedSubCategory = this.props.selectedSubCategory;
        var isDisabled = store.isSaving ||
            getCurrentSubcategoryLoadState() !== 1 /* Loaded */ ||
            !this.isFormDirty();
        return (React.createElement("div", { className: styles.settingsHeader },
            React.createElement("div", { className: styles.settingsTitle, role: "heading", "aria-level": 3 }, strings[selectedSubCategory.titleStringKey]),
            React.createElement("div", { className: styles.settingsHeaderButtons },
                store.isSaving && (React.createElement(Spinner, { size: SpinnerSize.large, className: styles.spinner })),
                !this.hideSaveDiscard() && [
                    React.createElement(PrimaryButton, { text: strings.optionsFull_save, disabled: isDisabled || this.shouldDisableSaveButton(), onClick: saveOptions, key: "save" }),
                    React.createElement(DefaultButton, { text: strings.optionsFull_cancel, disabled: isDisabled, onClick: discardOptions, key: "discard" }),
                ],
                React.createElement(IconButton, { iconProps: {
                        iconName: "Cancel" /* Cancel */,
                    }, onClick: this.hide }))));
    };
    SettingsFormHeader.prototype.hide = function () {
        hideFullOptions();
    };
    SettingsFormHeader.prototype.isFormDirty = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return isAnyOptionDirty(selectedSubCategory);
    };
    SettingsFormHeader.prototype.hideSaveDiscard = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return hideSaveDiscardButtons(selectedSubCategory);
    };
    SettingsFormHeader.prototype.shouldDisableSaveButton = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return shouldDisableSaveButton(selectedSubCategory);
    };
    SettingsFormHeader = tslib_1.__decorate([
        observer
    ], SettingsFormHeader);
    return SettingsFormHeader;
}(React.Component));
export default SettingsFormHeader;
//# sourceMappingURL=SettingsFormHeader.js.map